export default function scrollToTop(topPos = 0, smoothBehavior = true) {
  if (window)
    window.scrollTo({
      top: topPos,
      behavior: (smoothBehavior && 'smooth') || 'auto',
    });
}
